import { FunctionComponent } from "react";
import { Page } from "../Page";
import { surveySchema } from "../../utils/schemas";
import { Button, DynamicForm } from "am-tax-fe-core";
import { Box, Flex } from "@chakra-ui/react";

export const SurveyPage: FunctionComponent = () => {
    return (
        <Page title="Survey">
            <Flex padding="5rem" flexFlow="column nowrap" alignItems="stretch" gap="4rem" flex="1 1 100%" width="100%">
                {surveySchema.sections.map((section, index) => (
                    <Box key={index}>
                        <h2>{section.name}</h2>
                        <DynamicForm {...section.props} showSubmit={false} showReset={false} />
                    </Box>
                ))}
                <Button alignSelf="end">Submit</Button>
            </Flex>
        </Page>
    );
};
